module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Home/Ruller-3c49c12db17224512a59d8bedb781670.svg";